/**
 * @copyright 2019 @ DigiNet
 * @author THANH TRAM
 * @create 2019/06/28 09:10
 * @update 2019/06/28 09:10
 * @file src/actions/dropdown-actions.js
 */

import Api from '../../../services/api.js';
export default async (param)=> {
    // console.log("param param",param);
    return new Promise((resolve, reject) => {
        Api.put('/W17F0003/cbo-users', param)
            .then(result => {
                if (result && result.code && result.code !== 200) {
                    return resolve(0);
                } else {
                    return resolve(result.data);
                }
            });
    });
};
